import { render, staticRenderFns } from "./VerticalExportPage.vue?vue&type=template&id=38cb739f&scoped=true&"
var script = {}
import style0 from "./VerticalExportPage.vue?vue&type=style&index=0&id=38cb739f&lang=scss&scoped=true&"
import style1 from "./VerticalExportPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb739f",
  null
  
)

export default component.exports